import * as yup from "yup";

import { FormId } from "../../../../components/enums";
import {
  cityValidator,
  countryValidatorRequired,
  emailValidator,
  nameSurnameValidator,
  peselValidator,
  phoneValidator,
  postalCodePolandValidator,
  provinceValidator,
  streetValidator,
  streetHouseNumberValidator,
  postalCodeGenericValidator,
  insuranceCompanyValidator,
} from "../../../../utilities/validators";
import { trimmedString } from "../../../../utilities/validators/trimmedString";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.PERPETRATOR_DATA]: yup.object({
    [ComponentId.PERPETRATOR_NAME]: trimmedString.onlyIfFieldIsVisible(
      nameSurnameValidator
    ),
    [ComponentId.PERPETRATOR_SURNAME]: trimmedString.onlyIfFieldIsVisible(
      nameSurnameValidator
    ),
    [ComponentId.PERPETRATOR_PHONE]: phoneValidator("perpetratorphone"),
    [ComponentId.PERPETRATOR_EMAIL]: trimmedString.onlyIfFieldIsVisible(
      emailValidator
    ),
    [ComponentId.PERPETRATOR_PESEL]: trimmedString.onlyIfFieldIsVisible(
      peselValidator
    ),
    [ComponentId.PERPETRATOR_STREET]: trimmedString.onlyIfFieldIsVisible(
      streetValidator
    ),
    [ComponentId.PERPETRATOR_STREET_2]: trimmedString.onlyIfFieldIsVisible(
      streetHouseNumberValidator
    ),
    [ComponentId.PERPETRATOR_ZIP_CODE_PL]: trimmedString.onlyIfFieldIsVisible(
      postalCodePolandValidator
    ),
    [ComponentId.PERPETRATOR_ZIP_CODE_GENERIC]: trimmedString.onlyIfFieldIsVisible(
      postalCodeGenericValidator
    ),
    [ComponentId.PERPETRATOR_CITY]: trimmedString.onlyIfFieldIsVisible(
      cityValidator
    ),
    [ComponentId.PERPETRATOR_COUNTRY]: yup
      .object()
      .onlyIfFieldIsVisible(countryValidatorRequired),
    [ComponentId.PERPETRATOR_PROVINCE]: trimmedString.onlyIfFieldIsVisibleProvince(
      provinceValidator
    ),
    [ComponentId.PERPETRATOR_INSURANCE_COMPANY]: trimmedString.onlyIfFieldIsVisibleProvince(
      insuranceCompanyValidator
    ),
  }),
};
